var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-collapse",class:{
    closed: _vm.state === _vm.STATE_CLOSED,
    closing: _vm.state === _vm.STATE_CLOSING,
    opening: _vm.state === _vm.STATE_OPENING,
    opened: _vm.state === _vm.STATE_OPENED,
  }},[_c('div',{ref:"contentWrapper",staticClass:"content-wrapper",style:({ maxHeight: _vm.maxHeight })},[_c('div',{ref:"content"},[(!_vm.destroyOnClose || (_vm.destroyOnClose && _vm.state !== _vm.STATE_CLOSED))?_vm._t("default"):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }